import { motion } from "framer-motion";
import { Button } from "@heroui/react";
import { Lock, ArrowLeftCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white dark:bg-zinc-900 text-gray-800 dark:text-gray-200 p-6">
      
      {/* 🌟 Animation principale */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="text-center"
      >
        <div className="flex flex-col items-center">
          <div className="p-8 items-center justify-center rounded-full bg-opacity-15 flex w-[11vw] my-10">
            <Lock size={80} className="text-red-500 mb-4 animate-pulse" />
          </div>
          <h1 className="text-4xl font-bold mb-2">⛔ Accès refusé</h1>
          <p className="text-lg mb-6">
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          </p>

          {/* 🌈 Bouton retour animé */}
         
            <Button
              color="primary"
              startContent={<ArrowLeftCircle size={20} />}
              onPress={() => navigate(-1)}
            >
              Retour à la page précédente
            </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default Unauthorized;
